// utils/smsUrlGenerator.js
export const generateSmsUrl = (phoneNumber, message) => {
    const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');
  
    return `sms:${cleanedPhoneNumber}?body=${encodeURIComponent(message)}`;
  };